import { Box, Paper, Typography, useTheme } from "@mui/material";
import { projects } from "../constants";
import { MainProvider } from "../providers/MainProvider";

export default function Projects() {
  const { palette } = useTheme();
  const { update } = MainProvider.useAction();
  const { selectedProject } = MainProvider.useState();

  return (
    <Box mx={-0.5}>
      {projects.map((item, index) => (
        <Box
          key={index}
          sx={{
            cursor: "pointer",
            transition: "all 0.3s ease-in-out",
            "&:hover": {
              opacity: 0.44,
            },
            display: "inline-block",
            width: "10%",
            p: 0.5,
          }}
          onClick={() => {
            if (selectedProject?.name === item.name) {
              update({ selectedProject: null });
            } else {
              update({ selectedProject: item });
            }
          }}
        >
          <Box position={"relative"}>
            <Paper
              sx={{
                p: 2,
                ...(selectedProject?.name === item.name
                  ? {
                      backgroundImage: `url(${
                        item.backgroundImage || "/images/bg-default.png"
                      })`,
                      backgroundPosition: "center",
                      backgroundSize: "cover",
                      outline: "2px solid text.secondary",
                    }
                  : {}),
              }}
            >
              <Box
                component="img"
                src={item.image}
                alt={`Project ${index + 1}`}
                sx={{
                  width: "100%",
                  height: "50px",
                  objectFit: "contain",
                }}
              />
            </Paper>
            <Box
              sx={{
                backgroundColor:
                  palette.mode === "dark" ? "unset" : "rgba(255, 255, 255, .6)",
              }}
            >
              <Typography
                fontSize={10}
                fontWeight={900}
                align="center"
                color={
                  selectedProject?.name === item.name
                    ? "white"
                    : "text.secondary"
                }
              >
                {item.name}
              </Typography>
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
}
